import { useNavigate } from "react-router-dom";
import { Microphone, SquaresFour, BookmarkSimple, UserCircle } from "@phosphor-icons/react";

function Tab({ id, icon: Icon, label, onClick, active }) {
  return (
    <button data-testid={`mobile-tab-${id}`} onClick={onClick} className={`flex min-h-[52px] flex-1 flex-col items-center justify-center gap-0.5 text-[11px] font-medium transition-colors active:scale-95 ${active ? "text-brand" : "text-mist"}`}>
      <Icon size={22} weight={active ? "fill" : "regular"} />
      {label}
    </button>
  );
}

export function MobileTabBar({ onSpeak, onTemplates, onLibrary, active = "speak" }) {
  const navigate = useNavigate();
  return (
    <nav data-testid="mobile-tab-bar" data-html2canvas-ignore="true" className="stp-glass fixed inset-x-0 bottom-0 z-40 flex border-x-0 border-b-0 border-t border-black/5 px-2 pb-[env(safe-area-inset-bottom)] sm:hidden">
      <Tab id="speak" icon={Microphone} label="Speak" onClick={onSpeak} active={active === "speak"} />
      <Tab id="templates" icon={SquaresFour} label="Templates" onClick={onTemplates} active={active === "templates"} />
      <Tab id="library" icon={BookmarkSimple} label="Library" onClick={onLibrary} active={active === "library"} />
      <Tab id="account" icon={UserCircle} label="Account" onClick={() => navigate("/billing")} />
    </nav>
  );
}
